import { denormalisedResponseEntities } from '../util/data';
import { storableError } from '../util/errors';
import { currentUserShowSuccess } from './user.duck';

// ================ Action types ================ //

export const UPDATE_SUPPORT_CHATS_REQUEST = 'app/SupportChat/UPDATE_SUPPORT_CHATS_REQUEST';
export const UPDATE_SUPPORT_CHATS_SUCCESS = 'app/SupportChat/UPDATE_SUPPORT_CHATS_SUCCESS';
export const UPDATE_SUPPORT_CHATS_ERROR = 'app/SupportChat/UPDATE_SUPPORT_CHATS_ERROR';

// ================ Reducer ================ //

const initialState = {
  updateInProgress: false,
  updateError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_SUPPORT_CHATS_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateError: null,
      };
    case UPDATE_SUPPORT_CHATS_SUCCESS:
      return {
        ...state,
        updateInProgress: false,
      };
    case UPDATE_SUPPORT_CHATS_ERROR:
      return {
        ...state,
        updateInProgress: false,
        updateError: payload,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const updateSupportChatsRequest = () => ({
  type: UPDATE_SUPPORT_CHATS_REQUEST,
});

export const updateSupportChatsSuccess = result => ({
  type: UPDATE_SUPPORT_CHATS_SUCCESS,
  payload: result.data,
});

export const updateSupportChatsError = error => ({
  type: UPDATE_SUPPORT_CHATS_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //

export const updateUserSupportChats = (chatSessions) => {
  return (dispatch, getState, sdk) => {
    dispatch(updateSupportChatsRequest());

    // Get current user data to preserve existing publicData
    const { user } = getState();
    const currentUser = user.currentUser;
    const currentPublicData = currentUser?.attributes?.profile?.publicData || {};

    console.log('Current user:', currentUser?.id?.uuid);
    console.log('Current publicData:', currentPublicData);
    console.log('Updating with chat sessions:', chatSessions);

    const updatedPublicData = {
      ...currentPublicData,
      supportChatSessions: chatSessions,
    };

    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    const updateParams = {
      publicData: updatedPublicData,
    };

    console.log('Update params:', updateParams);

    return sdk.currentUser
      .updateProfile(updateParams, queryParams)
      .then(response => {
        console.log('Profile update successful:', response);
        dispatch(updateSupportChatsSuccess(response));

        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const updatedUser = entities[0];

        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(updatedUser));
        
        return updatedUser;
      })
      .catch(e => {
        console.error('Profile update failed:', e);
        dispatch(updateSupportChatsError(storableError(e)));
        throw e;
      });
  };
};

// Helper function to get support chats from user data
export const getUserSupportChats = (currentUser) => {
  return currentUser?.attributes?.profile?.publicData?.supportChatSessions || [];
};

// Helper function to add a new chat session
export const addSupportChatSession = (currentUser, newChatSession) => {
  const existingChats = getUserSupportChats(currentUser);
  
  // Check if chat session already exists to avoid duplicates
  const existingChatIndex = existingChats.findIndex(
    chat => chat.channelId === newChatSession.channelId
  );
  
  if (existingChatIndex >= 0) {
    // Update existing chat session
    const updatedChats = [...existingChats];
    updatedChats[existingChatIndex] = {
      ...updatedChats[existingChatIndex],
      ...newChatSession,
      lastActivity: new Date().toISOString(),
    };
    return updatedChats;
  } else {
    // Add new chat session
    return [...existingChats, {
      ...newChatSession,
      createdAt: new Date().toISOString(),
      lastActivity: new Date().toISOString(),
    }];
  }
};

// Helper function to update existing chat session
export const updateSupportChatSession = (currentUser, channelId, updates) => {
  const existingChats = getUserSupportChats(currentUser);
  
  const updatedChats = existingChats.map(chat => 
    chat.channelId === channelId 
      ? { ...chat, ...updates, lastActivity: new Date().toISOString() }
      : chat
  );
  
  return updatedChats;
};